import { render, staticRenderFns } from "./EditCharacteristics.vue?vue&type=template&id=240e08e8&scoped=true&"
import script from "./EditCharacteristics.vue?vue&type=script&lang=js&"
export * from "./EditCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./EditCharacteristics.vue?vue&type=style&index=0&id=240e08e8&scoped=true&lang=scss&"
import style1 from "./EditCharacteristics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e08e8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default,TheTinyInput: require('/web/components/TheTinyInput.vue').default,TheDecimalInput: require('/web/components/TheDecimalInput.vue').default,TinyButton: require('/web/components/TinyButton.vue').default,TheDatePicker: require('/web/components/TheDatePicker.vue').default})
